import React, { PureComponent } from "react";
import profileStore from "~/redux/profile/store";
import connect from "~/tools/connect"
import userStore from '~/redux/user/store';
import {
  getQuestions,
  updateProfile,
  updateUserQuestionAnswers,
  saveProfile,
  uploadImage,
  updateEditing,
  updateErrors,
  toggleInterest
} from "~/redux/profile/actions";
import PropTypes from "prop-types";
import { findQuestion } from "~/redux/profile/helpers";
import { validator, getAvatar, formatDate, getValidatedFieldValues } from "./helpers";
import { isEqual, forOwn } from "lodash";
import {fetchConcepts} from '~/redux/video/helpers';

//Higher order profile form for extending functionality
function ProfileForm (WrappedComponent) {

	const FormWrapper = class extends PureComponent {

		constructor(props){
			super(props);
			this.state = {interests: []};
		}

		componentDidMount() {
			profileStore.dispatch(getQuestions(this.state.user.userId));
			fetchConcepts().then( res => {
				//get rid of crappy data
				const interests = res.records.filter( i => {
					return i.gist.images != null;
				});

				this.setState({interests: interests});
			})
		}

		validationCallback = (validationResponse) => {
			const errorExistedBefore = this.state.errors[validationResponse.key]
			if(validationResponse.error || (errorExistedBefore && !validationResponse.error))
			{
			  profileStore.dispatch(
			    updateErrors({
			      key: validationResponse.key,
			      value: validationResponse.error
			    })
			  );
			}
		}

		updateField = (key, value) => {
			profileStore.dispatch(updateProfile(key, value));
		}

		//update input is passed an input onChange event
		updateInput = (e) =>{
			const payload = e.target;
			const { key, value } = validator(payload.name, payload.value, this.validationCallback);
			this.updateField(key, value);
		}

		updateDOB = date => {
			date = formatDate(date);
		  	const { key, value } = validator('DOB', date, this.validationCallback);
		  	profileStore.dispatch(updateProfile(key, value));
		};

		updateQuestion = (key, value) => {
			validator(key, value, this.validationCallback);
			profileStore.dispatch(updateUserQuestionAnswers(key, value));
		};

		emptyField = key => {
			profileStore.dispatch(updateProfile(key, ""));
		};

		updateEditing = e => {
			profileStore.dispatch(updateEditing(false));
		};

		toggleInterest = interest => {
			profileStore.dispatch(toggleInterest(interest));
		}

		save = e => {
			const userId  = this.state.user.userId;
			const profile = this.state.profile.data.main;
			const profileValues  = getValidatedFieldValues(profile)
			let hasErrors = false;

			// forOwn(profileValues, (value, key) => {
			//   const payload = { value, name: key };
			//   const validationResponse = validator(payload, this.validationCallback);
			//   if (validationResponse.error) {
			//     hasErrors = true;
			//   }
			//   console.log(validationResponse);
			// });

			if (!hasErrors) {
			  return profileStore.dispatch(saveProfile(userId, profile));
			}
		};

		saveEmpty = () => {
			return profileStore.dispatch(saveProfile(this.state.user.userId, {questions: [], interests: []}));
		};

		handleUpload = e => {
			const file = e.target.files[0];
			profileStore.dispatch(uploadImage(this.state.user.userId, file));
		};

		render() {
	      	return (
		        <div ref={el => this.wrapper = el}>
		          	<WrappedComponent 
		            	updateField={this.updateField}
		            	updateInput={this.updateInput}
		            	updateQuestion={this.updateQuestion}
		            	updateDOB={this.updateDOB}
		            	save={this.save}
		            	saveEmpty={this.saveEmpty}
		            	findQuestion={findQuestion}
		            	toggleInterest={this.toggleInterest}
		            	{...this.state}
		            	{...this.props}
		          	/>
		        </div>
	      	);
	    }

	};

	connect(FormWrapper, state => ({ user: state.user }), userStore);
	connect(FormWrapper, state => ({ 
	    profile: state.profile,
	    editing: state.editing,
	    saving: state.saving,
	    errors: state.errors,
	    questions: state.questions
	}), profileStore);

	return FormWrapper;
}

export default ProfileForm;
